import React from "react";
import { PlayerState } from "../../../core/protocol/types";
import { TEAM_NAMES, TEAM_COLORS } from "../../../core/constants";
import "./TeamSelector.css";

interface TeamSelectorProps {
  currentTeam: number;
  players: PlayerState[];
  onTeamChange: (team: number) => void;
  isServer: boolean;
  gameStatus: "waiting" | "starting" | "active" | "finished";
}

const TeamSelector: React.FC<TeamSelectorProps> = ({
  currentTeam,
  players,
  onTeamChange,
  isServer,
  gameStatus,
}) => {
  const canChangeTeam = gameStatus === "waiting";

  // Group players by team
  const playersByTeam: Map<number, PlayerState[]> = new Map();
  for (let i = 0; i < 8; i++) {
    playersByTeam.set(i, []);
  }
  players.forEach((player) => {
    const team = player.team ?? 0;
    const teamPlayers = playersByTeam.get(team) || [];
    teamPlayers.push(player);
    playersByTeam.set(team, teamPlayers);
  });

  return (
    <div className="team-selector">
      <h3 className="team-selector-title">Select Team</h3>
      <div className="team-selector-grid">
        {TEAM_NAMES.map((teamName, index) => {
          const teamPlayers = playersByTeam.get(index) || [];
          const isSelected = currentTeam === index;
          const isDisabled = !canChangeTeam;

          return (
            <button
              key={index}
              className={`team-option ${isSelected ? "selected" : ""} ${
                isDisabled ? "disabled" : ""
              }`}
              onClick={() => {
                if (!isDisabled && !isSelected) {
                  onTeamChange(index);
                }
              }}
              disabled={isDisabled}
              style={{
                borderColor: isSelected ? TEAM_COLORS[index] : "rgba(255, 255, 255, 0.2)",
                backgroundColor: isSelected
                  ? `${TEAM_COLORS[index]}20`
                  : "rgba(0, 0, 0, 0.3)",
              }}
            >
              <div
                className="team-color-indicator"
                style={{ backgroundColor: TEAM_COLORS[index] }}
              />
              <div className="team-info">
                <div className="team-name">{teamName}</div>
                <div className="team-players">
                  {teamPlayers.length === 0
                    ? "Empty"
                    : teamPlayers.map((p) => p.name).join(", ")}
                </div>
              </div>
              {isSelected && <div className="team-selected-badge">✓</div>}
            </button>
          );
        })}
      </div>
      {!canChangeTeam && (
        <p className="team-selector-note">
          Team selection is only available before the game starts.
        </p>
      )}
    </div>
  );
};

export default TeamSelector;

